<template>
  <div class="app-container">
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="100px">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="通道名称" prop="name">
              <el-input v-model="propsParams.name" placeholder="请输入通道名称"></el-input>
            </el-form-item>
            <el-form-item label="运营商:" prop="operationId">
              <el-select v-model="propsParams.operationId" filterable placeholder="请选择运营商"
                         @change="handleChangeOperation($event)">
                <el-option
                    v-for="item in options"
                    :key="item.operationId"
                    :label="item.operationName"
                    :value="item.operationId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="父通道" prop="parentChannelId">
              <el-select v-model="propsParams.parentChannelId" placeholder="请选择父通道" clearable
                         @change="handleChange($event)" @clear="handleClear">
                <el-option
                    v-for="item in optSourceShow"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道编码" prop="channel" v-if="showChannel">
              <el-input v-model="propsParams.channel" placeholder="请输入通道编码"></el-input>
            </el-form-item>

            <el-form-item label="AppID" prop="appid">
              <el-input v-model="propsParams.appid" placeholder="请输入AppID"></el-input>
            </el-form-item>
            <el-form-item label="AppSecret" prop="appsecret">
              <el-input v-model="propsParams.appsecret" placeholder="请输入AppSecret"></el-input>
            </el-form-item>
            <el-form-item label="OpenId" prop="openId" v-if="showOpenId">
              <el-input v-model="propsParams.openId" placeholder="请输入OpenId"></el-input>
            </el-form-item>
            <el-form-item label="AppKey1" prop="appkeyOne" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyOne" placeholder="请输入AppKey第一段"></el-input>
            </el-form-item>
            <el-form-item label="AppKey2" prop="appkeyTwo" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyTwo" placeholder="请输入AppKey第二段"></el-input>
            </el-form-item>
            <el-form-item label="AppKey3" prop="appkeyThree" v-if="showAppKey">
              <el-input v-model="propsParams.appkeyThree" placeholder="请输入AppKey第三段"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="类型" prop="type" label-width="120px">
              <el-radio-group v-model="propsParams.type">
                <el-radio v-model="propsParams.type" label="1">操作开关机</el-radio>
                <el-radio v-model="propsParams.type" label="2">操作网络状态</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注信息:" prop="remark" label-width="120px">
              <el-input v-model="propsParams.remark" placeholder="请输入备注信息"></el-input>
            </el-form-item>
            <el-form-item label="接口请求地址:" prop="url" label-width="120px">
              <el-input v-model="propsParams.url" placeholder="接口地址"></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="status" label-width="120px">
              <el-switch v-model="propsParams.status" active-value="1" inactive-value="0"
                         active-color="#13ce66"></el-switch>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { cardSourceSelectList,operationList } from "@/api/api.js"; //卡来源列表
import { addChannel } from "@/api/api.js"; //添加通道

export default {
  name: "AddChannel",
  data() {
    return {
      options: [],
      optSource: [],
      optSourceShow: [],
      propsParams: {
        type: "1",
        status: "1"
      },
      ruleValidate: {
        name: [{required: true, message: "请输入通道名称", trigger: "blur"}],
        operationId: [{required: true, message: "请选择运营商", trigger: "blur"}],
        channel: [{required: true, message: "请选择通道编号", trigger: "blur"}],
        appid: [{required: true, message: "请输入AppID", trigger: "blur"}],
        appsecret: [{required: true, message: "请输入AppSecret", trigger: "blur"}],
        type: [{required: true, message: "请选择类型", trigger: "blur"}],
        url: [{required: true, message: "请输入接口地址", trigger: "blur"}],
        status: [{required: true, message: "请选择是否启用", trigger: "blur"}],
      },
      // 控制框显示
      showOpenId: true,
      showAppKey: true,
      showChannel: true,
    };
  },
  components: {},
  computed: {},
  methods: {
    // 获取通道来源
    querySource() {
      cardSourceSelectList({}).then(res => {
        this.optSource = res.data.data;
      });
    },
    // 创建通道
    handleSubmit() {
      let params = {
        ...this.propsParams,
      };
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          addChannel(params).then(res => {
            if (res.data.code === 200) {
              this.$message.success("添加通道成功");
              this.$store.dispatch("tagsView/delView", this.$route);
              this.$router.replace({path: '/device/channelList'});
            } else if (res.data.code === 500) {
              this.$message.error("接口错误");
            }
          });
        }
      });
    },
    handleChangeOperation(event) {
      this.optSourceShow = this.optSource.filter(item => item.operationId === event);
      this.propsParams.parentChannelId = "";
    },
    handleChange(event) {
      let source = this.optSource.find(object => object.id === event);
      if (source.operationName === "中国联通") {
        this.showOpenId = true;
        this.showAppKey = false;
      } else {
        this.showOpenId = false;
        this.showAppKey = true;
      }
      this.showChannel = false;
    },
    handleClear() {
      this.showOpenId = true;
      this.showAppKey = true;
      this.showChannel = true;
    },
    initOperation() {
      operationList().then(res => {
        this.options = res.data.data;
      });
    }
  },
  mounted() {
  },
  created() {
    // 初始化获取运营商
    this.initOperation();
    this.querySource();
  }
};
</script>
